// import AssistivLogo from '@/assets/branding/assistiv/assistiv-logo.png';
import { AssistivLogoSVG } from '@/assets/branding/assistiv';

const colors = {
  // Brand colors
  brand_primary: '#0779FF',
  brand_primary_hover: '#175CD3',
  brand_primary_highlight: '#84CAFF',
  brand_primary_mid: '#1C86FF',
  brand_primary_dark: '#043E80',
  brand_secondary: '#2F6CCE',
  brand_accent_start: '#1570ef',
  brand_accent_end: '#9e77ed',
  brand_accent_light_start: '#f0f6ff',
  brand_accent_light_end: '#eee6ff',
  brand_complementary_accent: 'rgb(239,79,45)',
  brand_auth_gradient_mid: 'rgb(24,49,161)',
  brand_auth_gradient_end: 'rgb(1,36,151)',
  brand_auth_warp_mid: 'rgb(39,86,240)',
};

export default {
  name: 'Assistiv',
  isSAML: true,
  allowPersonalCourses: false,
  logo: AssistivLogoSVG,
  colors,
};
